import React, { useState, useEffect } from "react";

const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  // When scrolling, toggle visibility of the button
  const handleScroll = () => {
    if (window.scrollY > 100) { // Show button after scrolling 100px
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Scroll to top when the button is clicked
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll
    });
  };

  // Listen for scroll events
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button
      onClick={scrollToTop}
      style={{
        // width: "0",
        position: "fixed",
        bottom: "39px",
        // right: "20px",
        left: "45%",
transform: "translateX(665px)",
        padding: "12px 22px",
        backgroundColor: "#007bff",
        color: "white",
        border: "none",
        borderRadius: "50%",
        cursor: "pointer",
        fontSize: "20px",
        boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        zIndex: 9999, // Ensure it's above other content
        display: isVisible ? "block" : "none", // Hide button when not visible
      }}
    >
      ↑
    </button>
  );
};

export default ScrollToTopButton;
